const customerPayment = {
  customer_payments: `Customer Payments`,
  data_not_found_for_organization_id: `Data not found for organization ID:{{orgId}}`,
  "Days Sales Outstanding Report": "Days sales outstanding overview (Chart)",
  "Days Sales Outstanding Table": `Days sales outstanding details (Table)`,
  "Customer Company ID": "Customer Company ID",
  "Accounts Receivable at Period End": "Accounts Receivable at Period End",
  "Total Credit Sales in Period": "Total Credit Sales in Period",
  "Days Sales Outstanding": "Days Sales Outstanding",
  days_with_value: `{{value}} Days`,
  dso: `DSO`,
};

export default customerPayment;
